module.exports = __webpack_public_path__ + "img/6-2.a5bd1a5a.png";